<template>
  <div v-if="value" class="
    bg-gray-900
    bg-opacity-50
    bottom-0
    fixed
    flex
    h-full
    items-center
    justify-center
    left-0
    overflow-auto
    right-0
    scrolling-touch
    top-0
    w-full
    z-40"
    @click.self="close">
    <div class="sm:mx-4 sm:w-full w-modal-lg ">
      <div class="bg-white overflow-visible relative rounded">
        <button type="button" class="
          absolute
          duration-100
          ease-in-out
          flex
          focus:outline-none
          focus:ring-0
          h-4
          hover:text-gray-100
          items-center
          justify-center
          right-6
          top-6
          transition
        text-white
          w-6" @click="close">
          <i class="icon-cross text-white" />
        </button>
        <div class="bg-primary-500 block px-8 py-4 rounded-t sm:px-4 text-white w-full">
          <h1 class="text-center text-xl"> 我的領取條碼 </h1>
        </div>
        <div class="max-h-screen-1/2 overflow-y-auto scrolling-touch py-4 sm:py-5">
          <div class="flex justify-center">
            <div class="flex flex-col font-medium items-center py-4">
              <span>{{ receiveString }}</span>
              <w-date-time-display :dateTime="currentOrder.receive_time" hide-start-date
                text-class="font-medium text-black text-lg" />
              <canvas id="qrCode" />
            </div>
          </div>
          <div class="border-t border-gray-50" />
          <div class="max-h-[160px] mt-4 overflow-auto px-8 scrolling-touch sm:px-4">
            <div class="flex items-baseline justify-between">
              <div class="flex gap-2 items-baseline">
                <i class="icon-food mr-2" />
                <div class="flex flex-wrap gap-x-2 items-center">
                  <span class="text-gray-500 text-sm">
                    訂購時間：{{ getDateTimeText(currentOrder.created_at) }}
                  </span>
                </div>
              </div>
              <span class="font-medium">{{ currentOrder.total | commaFormat | priceFormat }}</span>
            </div>
            <div class="flex justify-between mt-2">
              <div class="flex flex-col gap-y-2">
                <div v-for="(entree, index) in currentOrder.order_contents"
                  :key="`${entree.entree_index}_${index}`" class="flex gap-1 text-sm">
                  <span class="min-w-[32px]">{{ entree.quantity }}x</span>
                  <div class="flex flex-col gap-1">
                    <div class="flex gap-1">
                      <span class="sm:max-w-[100px] max-w-[280px]">{{ entree.entree_name }}</span>
                      <span>{{ entree.entree_price | commaFormat | priceFormat }}</span>
                    </div>
                    <span v-if="getOptionItems(entree)"
                      class="sm:max-w-[100px] max-w-[280px] text-xs">
                      {{ getOptionItems(entree) }}
                    </span>
                    <span
                      v-if="entree.note"
                      class="sm:max-w-[100px] max-w-[280px] text-xs"
                    >
                      備註：{{ entree.note }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="orders.length > 1" class="rounded-b sm:px-4 px-6 py-4">
          <div class="flex justify-between">
            <w-button :disabled="currentPage <= 0" variant="icon" @click="currentPage -= 1">
              <i class="icon-chevron-left w-6" />
            </w-button>
            <span class="font-medium">第 {{ currentPage + 1 }} / {{ orders.length }} 訂購</span>
            <w-button :disabled="currentPage + 1 >= orders.length" class="rotate-180" variant="icon"
              @click="currentPage += 1">
              <i class="icon-chevron-left w-6" />
            </w-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QrCodeDialog from './QrCodeDialog';

export default QrCodeDialog;
</script>

<style lang="scss" scoped>
@import 'QrCodeDialog';
</style>
